/** Cloudflare Turnstile site key (VITE_TURNSTILE_SITE_KEY); empty = bot check off. */
export const TURNSTILE_SITE_KEY = (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) || "";
export const turnstileEnabled = Boolean(TURNSTILE_SITE_KEY);
